import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const safelaneeldConfig: TSPConfig = {
  key: 'safelaneeld',
  name: 'SafeLane ELD',
  imageName: 'SafeLaneELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your SafeLane ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default safelaneeldConfig;
